/*
 * @Descripttion:
 * @Author: lcf
 * @Date: 2020-12-27 21:51:08
 * @LastEditors: lcf
 * @LastEditTime: 2022-03-18 13:42:50
 */
/*
 * @Author: zhangshengwei
 */
/*
 * @Author: zhangshengwei
 */
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);
// 解决报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    meta: { title: "农机分布", keepAlive: true },
    component: () => import("@/views/Home"),
  },
  {
    path: "/cooperation",
    name: "Cooperation",
    component: () => import("@/views/Cooperation"),
  },
  {
    path: "/work_info",
    name: "WorkInfo",
    meta: { title: "作业进度", keepAlive: true },
    component: () => import("@/views/WorkInfo"),
  },
  {
    path: "/governmentAffairs/vehicleIdentify",
    name: "VehicleIdentify",
    meta: { title: "农机鉴定", keepAlive: false },
    component: () => import("@/views/GovernmentAffairs/vehicleIdentify"),
  },
  {
    path: "/governmentAffairs/purchaseAllowance",
    name: "PurchaseAllowance",
    meta: { title: "购置补贴", keepAlive: false },
    component: () => import("@/views/GovernmentAffairs/purchaseAllowance"),
  },
  {
    path: "/governmentAffairs/vehiclesupervisor",
    name: "Vehiclesupervisor",
    meta: { title: "农机监理", keepAlive: false },
    component: () => import("@/views/GovernmentAffairs/vehiclesupervisor"),
  },
  {
    path: "/governmentAffairs/scrapSubsidy",
    name: "ScrapSubsidy",
    meta: { title: "报废补贴", keepAlive: false },
    component: () => import("@/views/GovernmentAffairs/scrapSubsidy"),
  },

  {
    path: "/new_cooperative",
    name: "newCooperative",
    meta: { title: "合作社", keepAlive: false },
    component: () => import("@/views/newCooperative"),
  },
  {
    path: "/socialization",
    name: "Socialization",
    meta: { title: "社会化服务", keepAlive: false },
    component: () => import("@/views/Socialization"),
  },
  {
    path: "/aiDispatch",
    name: "AiDispatch",
    meta: { title: "智慧AI调度" },
    component: () => import("@/views/Dispatch"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

function getUrlParam(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  if (window.location.hash.indexOf("?") < 0) {
    return null;
  }
  let r = window.location.hash.split("?")[1].match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

router.beforeEach((to, form, next) => {
  // 如果没有登录则没有权限配置信息，此时需要通过 sessionStorate.token 获取并存储权限
  if (!store.getters.permissions || store.getters.permissions.length <= 0) {
    const token = sessionStorage.getItem("token");
    if (token) {
      store
        .dispatch("GetInfo")
        .then((res) => {
          console.log("%c通过token设置权限.res", "color:#0C0", res);
        })
        .catch((res) => {
          console.log("%c通过token设置权限.err", "color:#C00", res);
        })
        .finally(() => {
          next();
        });
      store
        .dispatch("getAreaPermissionsSetting")
        .then((res) => {
          console.log("%c通过token区域设置权限.res", "color:#0C0", res);
        })
        .catch((res) => {
          console.log("%c通过token区域设置权限.err", "color:#C00", res);
        })
        .finally(() => {
          next();
        });
      // 获取季度类型（返回SX三夏 SQ三秋
      store.dispatch("GetSeason");
    }
  } else {
    next();
  }
});

export default router;
